import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SiteFooter } from "@/components/SiteFooter";
import { BackgroundMusic } from "@/components/BackgroundMusic";
import { usePrefetchPortalCatalog } from "@/hooks/useTerms";

/** Portal shell: header + outlet + footer. Admin uses a separate route tree without this layout. */
export function SiteLayout() {
  // Start loading the word catalog on app open so Browse/Search feel instant.
  usePrefetchPortalCatalog();

  return (
    <>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="min-w-0 flex-1 overflow-x-clip">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
      {/* Ambient music — public pages only (admin has no SiteLayout). */}
      <BackgroundMusic />
    </>
  );
}
